<template>
  <div id="report_sub_pop" class="content">
    <div id="tab3" class="tab_content_area">
      <div class="content_box beforetab">
        <!-- <h2 class="content_title">{{ $t("msg.MYIN020T010.066") }}</h2> -->
        <tableau-viz id="tableauViz" :src="url" :token="$store.state.user.updateToken" height="800" width="1250" @firstinteractive="onFirstInteractive">
          <!-- <viz-parameter name="CST_NO" :value="cstCd"></viz-parameter> -->
          <!-- <viz-parameter name="POR_CTR_CD_PARAMETER" :value="ctrCd"></viz-parameter> -->

          <viz-parameter name="tabs" value="yes"></viz-parameter>
          <viz-parameter name="toolbar" value="top"></viz-parameter>
          <custom-parameter name=":tooltip" value="yes"></custom-parameter>
        </tableau-viz>
      </div>
    </div>
  </div>
</template>

<script>
import { rootComputed } from '@/store/helpers'
import jwt from 'jsonwebtoken'

export default {
  name: 'ReportDashboard',
  data () {
    return {
      customComponent: null,
      selectFunc: null,
      // url: 'https://tableau.ekmtc.com/views/__17683671878680/_',
      url: 'https://tableau.ekmtc.com/views/ekmtc_/sheet0',
      cstCd: this.getCstCd(),
      ctrCd: this.getCtrCd()
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    this.setToken()
  },
  mounted () {
    let viz = document.getElementById('tableauViz')
    if (viz) {
      viz.token = this.$store.state.user.updateToken
    }
    viz.toolbar = 'hidden'
  },
  methods: {
    // Promise.all을 적용한 매개변수 주입 최적화
    async onFirstInteractive (event) {
      const vizElement = event.target || document.getElementById('tableauViz')
      try {
        if (!vizElement) throw new Error('태블로 엘리먼트를 찾을 수 없습니다.')

        const workbook = vizElement.workbook

        if (workbook) {
          // Promise.all을 사용하여 여러 매개변수를 병렬로 동시에 변경
          await Promise.all([
            workbook.changeParameterValueAsync('CST_NO', this.cstCd),
            workbook.changeParameterValueAsync('POR_CTR_CD_PARAMETER', this.ctrCd)
          ])

          console.log('보안 매개변수 주입 성공:', this.cstCd, this.ctrCd)
        } else {
          console.warn('워크북 객체가 아직 로드되지 않았습니다.')
        }
      } catch (error) {
        console.error('매개변수 주입 중 오류 발생:', error.message)
      }
    },
    getCstCd () {
      return this.$store.state.auth.loginInfo.cstCd
    },
    getCtrCd () {
      return this.$store.state.auth.loginInfo.userCtrCd
    },
    setToken () {
      var token = this.$store.state.user.tableauToken
      if (this.$ekmtcCommon.isEmpty(token)) {
        var newToken = this.getToken()
        // $('#tableauViz').attr('token', newToken)
        this.$store.commit('user/updateToken', newToken)
      } else {
        let flag = this.verifyJWT(token)
        if (!flag) {
          newToken = this.getToken()
          // $('#tableauViz').attr('token', newToken)
          this.$store.commit('user/updateToken', newToken)
        }
      }
    },
    getToken () {
      const appClientId = this.$store.state.user.appClientId
      const appSecretKey = this.$store.state.user.appSecretKey
      const appSecretId = this.$store.state.user.appSecretId

      const token = jwt.sign({
        iss: appClientId,
        exp: Math.round(new Date().getTime() / 1000) + (10 * 60),
        jti: new Date().getTime().toString(),
        aud: 'tableau',
        sub: 'admin',
        CST_NO: this.cstCd,
        POR_CTR_CD_PARAMETER: this.ctrCd,
        scp: ['tableau:views:embed',
              'tableau:views:embed_authoring',
              'tableau:parameter:set' // 매개변수 변경 권한 추가
            ]
      },
      appSecretKey,
      {
        algorithm: 'HS256',
        header: {
          kid: appSecretId,
          iss: appClientId
        }
      })

      return token
    },
    // JWT 유효성 검증 함수
    verifyJWT (token) {
      try {
        const decoded = jwt.verify(token, this.$store.state.user.appSecretKey)
        // console.log('Decoded JWT:', decoded)
        return true
      } catch (error) {
        // console.error('JWT verification failed:', error.message)
        return false
      }
    }
  }
}
</script>
